<script setup>

import {computed, onMounted, reactive, ref} from "vue";

const props = defineProps({
    channelId: {
        type: Number,
        required: true,
    }
})

const reporting = reactive({
    channel: {},
    members: []
});

const search = ref('')

const loadChannel = async () => {
    const res = await axios.get(route('community.admin.api.reporting.channel', props.channelId));

    reporting.channel = res.data.channel;
    reporting.members = res.data.members;
}

const filteredMembers = computed(() => {
    return reporting.members.filter(member => {
        return member.name.toLowerCase().includes(search.value.toLowerCase());
    });
});

onMounted(() => {
    loadChannel();
});

</script>

<template>
    <div>
        <frosted-bar>
            <template #navigation>
                <a :href="route('community.admin.reporting.index')" class="mf-link">
                    {{ _mft('community:reporting.channels.title') }}
                </a>
            </template>
            <div class="flex items-center justify-between space-x-4">
                <h1>{{ reporting.channel.name ? reporting.channel.name : _mft('community:reporting.members.title') }}</h1>
                <a
                    class="mf-link"
                    :href="route('community.admin.reporting.channel-overview', props.channelId)"
                >
                    {{ _mft('community:reporting.overview.title') }}
                </a>
            </div>
        </frosted-bar>

        <div class="mt-6">
            <div class="flex justify-end">
                <input-text
                    v-model:content="search"
                    :placeholder="_mft('shared:search')"
                    class="w-48"
                ></input-text>
            </div>

            <list-basic>
                <list-basic-item
                    v-for="(member, c) in filteredMembers"
                    :key="c"
                >
                    <a class="mf-link" :href="route('community.admin.reporting.member', [props.channelId, member.id])">
                        {{ member.name }}
                    </a>
                </list-basic-item>
            </list-basic>
        </div>

    </div>
</template>
